import { render, staticRenderFns } from "./taskStatistics.vue?vue&type=template&id=79d92156&scoped=true"
import script from "./taskStatistics.vue?vue&type=script&lang=js"
export * from "./taskStatistics.vue?vue&type=script&lang=js"
import style0 from "./taskStatistics.vue?vue&type=style&index=0&id=79d92156&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d92156",
  null
  
)

export default component.exports